import { IonButton, IonButtons, IonContent, IonHeader, IonInput, IonItem, IonList, IonModal, IonTitle, IonToolbar } from "@ionic/react"
import { useEffect, useState } from "react";
import * as stt_settings from '@/controllers/stt_settings'
import { globalSTT as stt} from '@/components/Chat/STT';


const AvatarSettings = ({ref}) => {
    const avatarMenuRef = ref; //useRef<HTMLIonModalElement>(null);

    const [settings, setSettings] = useState({});

    const loadSettings = async () => setSettings(await stt_settings.get());
    useEffect(() => {
        loadSettings();
    }, [])

    const reset = async () => {
       await stt_settings.reset()
       setSettings(await stt_settings.get())
       await loadSettings();
    }

    const updateSettings = async (change) => {
       setSettings(await stt_settings.change(change))
       if (!stt.vad) return;

       const saved_settings = await stt_settings.get();
       stt.vad.options.positiveSpeechThreshold = saved_settings.positiveSpeechThreshold
       stt.vad.options.negativeSpeechThreshold = saved_settings.negativeSpeechThreshold
       stt.vad.options.redemptionFrames = saved_settings.redemptionFrames
       stt.vad.options.minSpeechFrames = saved_settings.minSpeechFrames
    //    stt.vad.setOptions({
    //         positiveSpeechThreshold: saved_settings.positiveSpeechThreshold,
    //         negativeSpeechThreshold: saved_settings.negativeSpeechThreshold,
    //         redemptionFrames: saved_settings.redemptionFrames,
    //         minSpeechFrames: saved_settings.minSpeechFrames
    //    })
       console.log(stt.vad.options);
       //stt.stop()
       //await stt.start()
    }

    return (
    <IonModal style={{'--height': '31em', '--width': '25em'}} ref={avatarMenuRef}>
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="start">
                    <IonButton onClick={() => avatarMenuRef.current?.dismiss()}>Cancel</IonButton>
                </IonButtons>
                <IonTitle>Avatar Settings</IonTitle>
                <IonButtons slot="end">
                    <IonButton strong={true} onClick={() => avatarMenuRef.current?.dismiss(null, 'confirm')}>
                        Confirm
                    </IonButton>
                </IonButtons>
            </IonToolbar>
        </IonHeader>
        <IonContent className="ion-padding">
            <IonList>
                <IonItem button={true} onClick={() => reset()}>Reset</IonItem>
                <IonItem><IonInput labelPlacement="stacked" label="positiveSpeechThreshold"
                    value={settings.positiveSpeechThreshold}
                    onIonChange={(e) => {updateSettings({
                        positiveSpeechThreshold: parseFloat(e.detail.value!)
                    })}}
                ></IonInput></IonItem>
                <IonItem><IonInput labelPlacement="stacked" label="negativeSpeechThreshold"
                    value={settings.negativeSpeechThreshold}
                    onIonChange={(e) => {updateSettings({
                        negativeSpeechThreshold: parseFloat(e.detail.value!)
                    })}}
                ></IonInput></IonItem>
                <IonItem><IonInput labelPlacement="stacked" label="redemptionFrames"
                    value={settings.redemptionFrames}
                    onIonChange={(e) => {updateSettings({
                        redemptionFrames: parseFloat(e.detail.value!)
                    })}}
                ></IonInput></IonItem>
                <IonItem><IonInput labelPlacement="stacked" label="minSpeechFrames"
                    value={settings.minSpeechFrames}
                    onIonChange={(e) => {updateSettings({
                        minSpeechFrames: parseFloat(e.detail.value!)
                    })}}
                ></IonInput></IonItem>
                <IonItem><IonInput labelPlacement="stacked" label="whisperMinNoSpeechProb"
                    value={settings.whisperMinNoSpeechProb}
                    onIonChange={(e) => {updateSettings({
                        whisperMinNoSpeechProb: parseFloat(e.detail.value!)
                    })}}
                ></IonInput></IonItem>
            </IonList>
            <p className="p-4">
            Learn more at <a href="https://test.vad.ricky0123.com/#opts=%7B%22positiveSpeechThreshold%22%3A0.5%2C%22negativeSpeechThreshold%22%3A0.35%2C%22preSpeechPadMs%22%3A30%2C%22redemptionMs%22%3A500%2C%22minSpeechMs%22%3A250%2C%22submitUserSpeechOnPause%22%3Afalse%2C%22baseAssetPath%22%3A%22https%3A%2F%2Fcdn.jsdelivr.net%2Fnpm%2F%40ricky0123%2Fvad-web%400.0.20%2Fdist%2F%22%2C%22onnxWASMBasePath%22%3A%22https%3A%2F%2Fcdn.jsdelivr.net%2Fnpm%2Fonnxruntime-web%401.14.0%2Fdist%2F%22%2C%22model%22%3A%22v5%22%2C%22startOnLoad%22%3Atrue%2C%22userSpeakingThreshold%22%3A0.6%7D">https://test.vad.ricky0123.com/</a>
            </p>
        </IonContent>
    </IonModal>)
}

export default AvatarSettings